import store from '@/store';
export default {
  height: "auto",
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchSpan: 5,
  searchMenuSpan: 4,
  border: true,
  index: true,
  viewBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  selection: false,
  dialogClickModal: false,
  searchIcon: true,
  searchIndex: 7,
  searchLabelWidth: 100,
  column: [
    {
      label: "所属代理商",
      prop: "createDept",
      type: "select",
      filterable: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      searchOrder: 100,
      hide: true,
      dicData: [],
      props: {
        label: "title",
        value: "id",
      },
    },
    {
      label: "进件编号",
      prop: "businessCode",
      type: "input",
      search: true,
      searchOrder: 98,
    },
    {
      label: "姓名",
      prop: "name",
      type: "input",
      width: 100,
      search: true,
      searchOrder: 97,
    },
    {
      label: "产品类型",
      prop: "rentType",
      type: "select",
      dicData: store.getters.porductTypes,
    },
    {
      label: "产品类型",
      prop: "rentTypeList",
      type: "select",
      dicData: store.getters.porductTypes,
      searchMultiple: true,
      hide: true,
      search: true,
      searchOrder: 99,
      cascader: ['lendingRate']
    },
    {
      label: "租赁金额",
      prop: "lendingAmount",
    },
    {
      label: "租期",
      prop: "tenancy",
      type: "input",
      formatter:(val,value,label)=>{
        return value ? value + "期" : "-";
      }
    },
    {
      label: "租率",
      prop: "lendingRate",
      type: "select",
      searchOrder: 40,
      formatter:(val,value,label)=>{
        return value ? value + "%" : "-";
      }
    },
    {
      label: "车牌号",
      prop: "carFirstNumber",
      type: "input",
      search: false,
      searchOrder: 96,
      slot: true,
    },
    {
      label: "审核节点",
      prop: "auditNode",
      slot: true,
      search: false,
      searchOrder: 95,
    },
    {
      label: "创建时间",
      prop: "createTime",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
    }
  ],
};
